
import { Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, list_type, bool_type, option_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { CustomProperty_$reflection } from "../../Shared/PropertyConfiguration.js";
import { Role__ToI18nString } from "../../Shared/Shared.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { singleton as singleton_1, toArray, ofArray, contains, filter, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { createObj, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { toArray as toArray_1, empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { InformationAlert } from "../../Components/Alert.js";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { Table_customPropertyColumnDefinitions } from "../../Widgets/CustomProperties.js";
import User_Add_Plus from "../../../public/assets/icons/User_Add_Plus.svg";
import { TableControlElement$1, TableControl$1 } from "../../Widgets/Table/Table.js";

export class StocktakingUserRow extends Record {
    constructor(Id, Name, Department, PersonnelNumber, Contact, RoleLabel, EmailLinkAddress, IsSelectable, CustomProperties) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Department = Department;
        this.PersonnelNumber = PersonnelNumber;
        this.Contact = Contact;
        this.RoleLabel = RoleLabel;
        this.EmailLinkAddress = EmailLinkAddress;
        this.IsSelectable = IsSelectable;
        this.CustomProperties = CustomProperties;
    }
}

export function StocktakingUserRow_$reflection() {
    return record_type("Stocktaking.Dialog.AddStocktakingUserModal.StocktakingUserRow", [], StocktakingUserRow, () => [["Id", string_type], ["Name", string_type], ["Department", string_type], ["PersonnelNumber", string_type], ["Contact", string_type], ["RoleLabel", option_type(string_type)], ["EmailLinkAddress", option_type(string_type)], ["IsSelectable", bool_type], ["CustomProperties", list_type(CustomProperty_$reflection())]]);
}

export function userRow(user) {
    let matchValue;
    return new StocktakingUserRow(user.Id, user.Name, user.Department, user.PersonnelNumber, (matchValue = user.LoginInformation, (matchValue.tag === 1) ? matchValue.fields[0] : matchValue.fields[0]), Role__ToI18nString(user.Role), undefined, true, user.CustomProperties);
}

export function employeeRow(candidate) {
    return new StocktakingUserRow(candidate.Id, candidate.Name, candidate.Department, "", defaultArg(candidate.EmailLinkAddress, ""), undefined, candidate.EmailLinkAddress, candidate.EmailLinkAddress != null, empty());
}

export function countingModeLabel(t, row) {
    const matchValue = row.EmailLinkAddress;
    if (matchValue == null) {
        if (row.IsSelectable) {
            if (row.RoleLabel == null) {
                return t("stocktaking.email_link.no_email_hint");
            }
            else {
                return t("stocktaking.email_link.app_badge");
            }
        }
        else {
            return t("stocktaking.email_link.no_email_hint");
        }
    }
    else {
        const email = matchValue;
        return concat(t("stocktaking.email_link.badge"), ": ", ...email);
    }
}

export function AddStocktakingUserModal(props) {
    let elems_2;
    const t = useTranslation()[0];
    const rows = filter((row) => !contains(row.Id, props.SelectedUserIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), props.Rows);
    return createElement(ModalSheet, {
        CloseButtonTestId: "close-stocktaking-modal-button",
        Content: reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "p-4", "flex", "flex-col", "gap-4"])], (elems_2 = toList(delay(() => {
            let elems;
            return append(props.ShowCountingMode ? singleton(reactElement("div", createObj(ofArray([["data-test-id", "stocktaking-email-link-selection-hint"], (elems = [createElement(InformationAlert, {
                Label: "stocktaking.email_link.selection_hint",
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty_1(), delay(() => {
                let elems_1, TableRows, Options;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "basis-[36rem]", "min-h-[36rem]", "overflow-hidden"])], (elems_1 = [createElement(InfiniteTable, (TableRows = toArray(rows), (Options = {
                    BorderStyle: "full",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["name", "asc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    RowSelection: "multiRow",
                    SaveTableConfiguration: false,
                    WithQueryParameters: false,
                }, {
                    ColumnDefinitions: toArray_1(delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (row_1) => (new CellContent(0, [row_1.Name])), "text", "text")), delay(() => append(props.ShowCountingMode ? singleton(new ColumnDefinition$1("countingMode", "", t("stocktaking.email_link.counting_mode"), (row_2) => (new CellContent(0, [countingModeLabel(t, row_2)])), "select", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("department", "", t("user.department"), (row_3) => (new CellContent(0, [row_3.Department])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("personnelNumber", "", t("user.personnel_number"), (row_4) => (new CellContent(0, [row_4.PersonnelNumber])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("emailPhoneNumber", "", t("user.email_mobile_number"), (row_5) => (new CellContent(0, [row_5.Contact])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("role", "", t("general.role"), (row_6) => {
                        let matchValue;
                        return new CellContent(0, [(matchValue = row_6.RoleLabel, (matchValue == null) ? t("receivers.employee") : t(matchValue))]);
                    }, "select", "text")), delay(() => Table_customPropertyColumnDefinitions(props.PropertyConfigurations, t("tool.custom_properties"), (row_7) => row_7.CustomProperties, t, props.Currency))))))))))))))),
                    Controls: singleton_1(new TableControlElement$1(0, [new TableControl$1(t("stocktaking.add"), User_Add_Plus(), props.OnSave, false, false, "stocktaking-add-button")])),
                    Options: Options,
                    TableKey: "stocktaking-add-users",
                    TableRows: TableRows,
                })))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: t("stocktaking.assign_helping_person"),
    });
}

